/**
 * When using factory methods to produce functions, you may sometimes run into
 * circular dependencies. This can be used in those cases to avoid errors
 *
 * __NOTE:__ this creates a new function with the same call signature as the old
 * function. It will not inherit any properties from the old function. This is
 * not usually an issue, unless you are using a factory that does some advanced
 * stuff under the hood
 *
 * @example
 * const myFunction = lazy(() => factoryThatIsImportedAsPartOfCircularDependency.createFunction(...))
 * myFunction(...)
 */
export function lazy<TFn extends (...args: any) => any>(
  producer: () => TFn,
): TFn {
  let fn: TFn | undefined
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument
  return ((...args) => (fn ??= producer())(...args)) as TFn
}
